<template>
  <b-row class="pagination-row">
    <div class="my-1">
      <b-form-group
        label="Per page"
        label-cols-sm="6"
        label-cols-md="4"
        label-cols-lg="3"
        label-align-sm="right"
        label-size="sm"
        label-for="perPageSelect"
        class="mb-0 ml-0 pl-0 align-left"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPageProxy"
          class="custom-select-ffs"
          size="sm"
          :options="pageOptionsProxy"
        ></b-form-select>
      </b-form-group>
    </div>
    <div class="my-1">
      <b-pagination
        v-model="currentPageProxy"
        :total-rows="totalRowsProxy"
        :per-page="perPageProxy"
        align="fill"
        size="sm"
        class="my-0"
      ></b-pagination>
    </div>
  </b-row>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    pageOptions: {
      type: Array,
      required: true
    },
    totalRows: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      currentPageProxy: null,
      perPageProxy: null,
      pageOptionsProxy: null,
      totalRowsProxy: null
    }
  },
  watch: {
    currentPage(val) {
      this.currentPage = val
    },
    currentPageProxy(val) {
      this.$parent.currentPage = val
    },
    perPage(val) {
      this.perPageProxy = val
    },
    perPageProxy(val) {
      this.$parent.perPage = val
    },
    pageOptions(val) {
      this.pageOptionsProxy = val
    },
    pageOptionsProxy(val) {
      this.$parent.pageOptions = val
    },
    totalRows(val) {
      this.totalRowsProxy = val
    },
    totalRowsProxy(val) {
      this.$parent.totalRows = val
    }
  },
  created() {
    this.currentPageProxy = this.currentPage
    this.perPageProxy = this.perPage
    this.pageOptionsProxy = this.pageOptions
    this.totalRowsProxy = this.totalRows
  }
}
</script>

<style scoped>
.pagination-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.pagination-row > :first-child {
  padding-left: 0 !important;
  width: 15rem;
  margin-left: 1rem;
}

.pagination-row > :last-child {
  padding-right: 0 !important;
}

.custom-select-ffs {
  width: auto;
}
</style>
